import { render, staticRenderFns } from "./RoomBooking.vue?vue&type=template&id=098de6d0"
import script from "./RoomBooking.vue?vue&type=script&lang=js"
export * from "./RoomBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports